export default __webpack_public_path__ + "static/media/logo_showys.89ff281c.png";